import { Component } from "react";
import Header from "../component/header";
import { FaArrowRight } from "react-icons/fa6";

import { RiStockLine } from "react-icons/ri";
import { TbScript } from "react-icons/tb";
import { LiaCoinsSolid } from "react-icons/lia";
import { BsBuildings } from "react-icons/bs";

import { IoCheckmarkDoneOutline } from "react-icons/io5";

import Icon from "../asset/images/icon-3.png"
import Icon1 from "../asset/images/icon-4.png"
import Icon2 from "../asset/images/icon-5.png"
import Footer from "../component/landing_footer";


// import Background from "../asset/images/background.jpg"
import Background from "../asset/images/about.jpeg"

import Leader from "../asset/images/lead.jpeg"
import Leader1 from "../asset/images/lead1.jpeg"
import Leader2 from "../asset/images/lead2.jpeg"

import Service from "../asset/images/service.jfif"
import ChatBox from "../component/chatbox";
import { Link } from "react-router-dom";


class LandingPage extends Component {
    state = {
        user: []
    }
    componentDidMount() {
        const savedUser = localStorage.getItem("teslaUserInfo");
        if (savedUser) {
            const userData = JSON.parse(savedUser);
            this.setState({
                user: {
                    firstName: userData.firstName || "",
                    lastName: userData.lastName || "",
                    userPlan: userData.userPlan || ""
                }
            });
        }
    }
    render() {
        const { user } = this.state
        const isLoggedIn = user && Object.keys(user).length > 0;
        return (
            <>
                <div className="landing_main_body">
                    {/* <img src={Background} alt="background" className="background"/> */}
                    <Header />
                    <div className="landing_main_cover">
                        <section className="landing_content">
                            <h1>Driving Your Future Forward</h1>
                            <p>Empowering your journey with innovative solutions, start building your future with us today.</p>
                            <div className="button">
                                <Link to={isLoggedIn ? "/Dashboard" : "/login"}> <button >Get started <FaArrowRight /></button></Link>
                            </div>
                            <div className="writeup">
                                <h3>
                                    <RiStockLine />
                                    <br />
                                    <span>Stocks</span>
                                </h3>
                                <h3>
                                    <TbScript />
                                    <br />
                                    <span>ETFs</span>
                                </h3>
                                <h3>
                                    <LiaCoinsSolid />
                                    <br />
                                    <span>Crypto</span>
                                </h3>

                                <h3>
                                    <BsBuildings />
                                    <br />
                                    <span>Real Estate</span>
                                </h3>
                            </div>
                        </section>
                        <section className="landing_content">
                            <button className="arrow">
                                <FaArrowRight />
                            </button>
                        </section>
                    </div>

                </div>



                <div className="landing_about_contain">
                    <div className="about_background_style1"></div>
                    <div className="about_background_style2"></div>
                    <div className="landing_about_cover">
                        <section className="about_image">
                            <img src={Background} alt="" />
                        </section>
                        <section className="about_content">
                            <h2>
                                <span>ABOUT US</span><br />
                                Discover Who We Are
                            </h2>
                            <p>
                                Tesla Safe Trade is a trusted leader in online brokerage, known for executing the first electronic trade by an individual investor over a decade ago.
                                <br /><br />
                                Our trading guides help all skill levels. A 21% account fee covers management, signals, insurance, and VAT, and must be paid before withdrawal approval.
                                <br /><br />
                                Stay updated with daily market videos, breaking news, and expert analysis—giving you key insights, technical levels, and economic events that move the markets.
                            </p>
                        </section>
                    </div>
                </div>





                <div className="landing_leaders_container">
                    <div className="landing_leader_cover">
                        <div className="head">
                            <h2>Our Leaders</h2>
                            <h3>Guiding Our Vision</h3>
                        </div>
                        <div className="leader_contain">
                            <section className="about leader_content">
                                <div className="image">
                                    {/* <h2>124K</h2> */}
                                    <img src={Leader1} alt="leader" />
                                </div>
                                <h3><span>Manager</span><br />
                                    Jared Birchall</h3>
                                {/* <p>Leading companies optimize operations and maximize profit by using GeoGIS for site selection, logistics, and risk modeling.</p> */}

                            </section>
                            <section className="leader_content about">
                                <div className="image">
                                    {/* <h2>30K</h2> */}
                                    <img src={Leader} alt="leader1" />
                                </div>
                                <h3><span>CEO & Founder</span><br />
                                    Elon Musk</h3>
                                {/* <p>Agencies rely on GeoGIS for public safety, resource management, and coordinating large-scale emergency responses for better governance.</p> */}

                            </section>
                            <section className="leader_content about">
                                <div className="image">
                                    {/* <h2>45K</h2> */}
                                    <img src={Leader2} alt="leader2" />
                                </div>
                                <h3><span>Board Chairman</span><br />
                                    Arete Musk</h3>
                                {/* <p> Non-profits use GeoGIS to map community needs, allocate aid efficiently, and visualize program impact for fundraising and outreach.</p> */}

                            </section>
                        </div>
                    </div>
                </div>






                <div className="landing_about_contain">
                    <div className="landing_about_cover equal">
                        <section className="about_content">
                            <h2>
                                <span>Service</span><br />
                                What We Offer
                            </h2>
                            <p>Tesla Investment & Stocks has been giving best consultation to top Finance companies since 2012</p>
                            <li>
                                <img src={Icon} alt="icon" />
                                <h4>
                                    10+ Years In Business
                                    <br />
                                    <span>We are experienced in what we do and are guaranteed to give the best</span>
                                </h4>
                            </li>

                            <li>
                                <img src={Icon1} alt="icon1" />
                                <h4>
                                    5,000,000+ Happy Investors
                                    <br />
                                    <span>Based on past feedback from investors, we can beat our chest that we are one of the best in the industry</span>
                                </h4>
                            </li>

                            <li>
                                <img src={Icon2} alt="icon2" />
                                <h4>
                                    24/7 Customer Support
                                    <br />
                                    <span>We are experienced in what we do and are guaranteed to give the best</span>
                                </h4>
                            </li>
                        </section>
                        <section className="about_image">
                            <img src={Service} alt="service" className="service" />
                        </section>
                    </div>
                </div>







                <div className="landing_invest_container">
                    <div className="landing_invest_cover">
                        <h2>
                            <span>Plans</span><br />
                            Our Investment Plans
                        </h2>

                        <div className="investment_contain">
                            <section className="investment_cover">
                                <h3> Basic </h3>
                                <div className="list">
                                    <li><IoCheckmarkDoneOutline /> Min: $500</li>
                                    <li><IoCheckmarkDoneOutline /> Max: $4,999  </li>
                                    <li><IoCheckmarkDoneOutline /> Duration: 72 Hours</li>
                                    <li><IoCheckmarkDoneOutline /> Multiple Investments Allowed </li>
                                    <li><IoCheckmarkDoneOutline /> 24/7 Customer Care</li>
                                    {/* <li><IoCheckmarkDoneOutline /> Lorem eru isuu ayea </li> */}
                                </div>
                                <div className="button">
                                    <Link to={isLoggedIn ? "/Dashboard" : "/login"}> <button>Start Investing</button></Link>
                                </div>
                            </section>
                            <section className="investment_cover">
                                <h3> Silver</h3>
                                <div className="list">
                                    <li><IoCheckmarkDoneOutline /> Min: $5000</li>
                                    <li><IoCheckmarkDoneOutline /> Max: $9,999  </li>
                                    <li><IoCheckmarkDoneOutline /> Duration: 7 Days</li>
                                    <li><IoCheckmarkDoneOutline /> Multiple Investments Allowed </li>
                                    <li><IoCheckmarkDoneOutline /> 24/7 Customer Care</li>
                                </div>
                                <div className="button">
                                    <Link to={isLoggedIn ? "/Dashboard" : "/login"}><button>Start Investing</button></Link>
                                </div>
                            </section>
                            <section className="investment_cover">
                                <h3> Gold </h3>
                                <div className="list">
                                    <li><IoCheckmarkDoneOutline /> Min: $10,000</li>
                                    <li><IoCheckmarkDoneOutline /> Max: $24,999  </li>
                                    <li><IoCheckmarkDoneOutline /> Duration: 14 Days</li>
                                    <li><IoCheckmarkDoneOutline /> Multiple Investments Allowed </li>
                                    <li><IoCheckmarkDoneOutline /> 24/7 Customer Care</li>
                                </div>
                                <div className="button">
                                    <Link to={isLoggedIn ? "/Dashboard" : "/login"}><button>Start Investing</button></Link>
                                </div>
                            </section>
                            <section className="investment_cover">
                                <h3> Platinum </h3>
                                <div className="list">
                                    <li><IoCheckmarkDoneOutline /> Min: $25,000</li>
                                    <li><IoCheckmarkDoneOutline /> Max: $50,000  </li>
                                    <li><IoCheckmarkDoneOutline /> Duration: 28 Days</li>
                                    <li><IoCheckmarkDoneOutline /> Multiple Investments Allowed </li>
                                    <li><IoCheckmarkDoneOutline /> 24/7 Customer Care</li>
                                </div>
                                <div className="button">
                                    <Link to={isLoggedIn ? "/Dashboard" : "/login"}><button>Start Investing</button></Link>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>


                {
                    isLoggedIn
                        ? <ChatBox />
                        : null
                }


                <Footer />

            </>
        )
    }
}


export default LandingPage